// Central site/business config used across the marketing site

export const BUSINESS = {
  name: "30A Health Insurance",
  shortName: "30A Health",
  tagline: "Personalized health coverage for the Emerald Coast.",
  broker: "Christian Regalado",
  brokerTitle: "Licensed Insurance Broker",
  phone: "850-687-7606",
  phoneRaw: "+18506877606",
  email: "christian@30ahealthins.com",
  address: "Santa Rosa Beach, FL 32459",
  hours: "Mon – Fri · 9:00 AM – 6:00 PM CT",
  experience: "7+ years of experience · Licensed in Florida & Colorado",
  states: ["Florida", "Colorado"],
};

export const CARRIERS = [
  "Florida Blue",
  "Humana",
  "United Healthcare",
  "Aetna",
  "Allstate",
  "HealthSpring",
  "Devoted",
  "WellCare",
];

// Carriers hidden from the homepage grid until carrier-approved artwork is supplied
export const HIDDEN_CARRIER_TILES = ["Florida Blue"];

// Carrier-approved logo artwork (rendered instead of the text tile when present)
export const CARRIER_LOGOS = {
  Humana: { src: "/carriers/humana.png", alt: "Humana", width: 156, height: 42 },
};

export const PLAN_TYPES = [
  "ACA Health",
  "Medicare Advantage",
  "Medicare Supplement",
  "Dental",
  "Hospital Indemnity",
  "Cancer Plans",
  "Long Term Care",
  "Final Expense",
  "Not Sure",
];
